import React from "react";
import { motion } from "framer-motion";

const SectionHeading = ({ tag, title, subtitle, center = false, className = "" }) => (
  <motion.div
    className={`${center ? "text-center" : ""} ${className}`}
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
  >
    {tag && <span className="section-tag">{tag}</span>}
    <h2 className="section-heading">{title}</h2>
    {subtitle && (
      <p className="mt-3 text-gray-400 font-sans text-lg max-w-2xl mx-auto leading-relaxed">
        {subtitle}
      </p>
    )}
  </motion.div>
);

export default SectionHeading;
